import { Column } from 'material-table';
import { PaginationQuery, IBaseAction } from '../../constants/types'

//==========================================
//==========================================

export interface PartyListTableState {
    columns: Array<Column<Party>>;
    data: Party[];
    options: any;
    actions: UserAction[];
}
export interface PartyListState {
    data: Party[];
    total: 0;
}

interface UserAction {
    icon: any;
    tooltip: string;
    onClick: any;
}

//==========================================
export const INSERT_PARTY = 'INSERT_PARTY';
export const INSERT_PARTY_SUCCESS = 'INSERT_PARTY_SUCCESS';
export const INSERT_PARTY_FAILURE = 'INSERT_PARTY_FAILURE';

export const GET_PARTY = 'GET_PARTY';
export const GET_PARTY_SUCCESS = 'GET_PARTY_SUCCESS';
export const GET_PARTY_FAILURE = 'GET_PARTY_FAILURE';
interface GetPartyAction extends IBaseAction {
    type: typeof GET_PARTY | typeof GET_PARTY_SUCCESS
    payload: {
        data: Party
    },
}

export const UPDATE_PARTY = 'UPDATE_PARTY';
export const UPDATE_PARTY_SUCCESS = 'UPDATE_PARTY_SUCCESS';
export const UPDATE_PARTY_FAILURE = 'UPDATE_PARTY_FAILURE';

export const DELETE_PARTY = 'DELETE_PARTY';
export const DELETE_PARTY_SUCCESS = 'DELETE_PARTY_SUCCESS';
export const DELETE_PARTY_FAILURE = 'DELETE_PARTY_FAILURE';

export interface Party {
    email: string;
    fullName: string;
    partyCd: string;
    operatorCode: number;
    operatorOnlineMethod: string;
    partyTypeCd: string;
    partySex: string;
    lastName: string;
    firstName: string;
    middleName: string;
    organizationName: string;
    operatorFileName: string;
    managerCd: string;
    isAgent: boolean;
    isTelRequired: boolean;
    telExt: string;
    mobileNumber: string;
    hasRemoteAccess: boolean;
    outputTrunk: string;
    active: boolean;
    contactContentLoggingEnabled: number;
    password1: string;
    password2: string;
    announceName: boolean;
    synchAgentRemoteAddrAndExtensionHost: boolean;
}
export const partyInit: Party = {
    partyCd: "",
    fullName: "",
    email: "",
    operatorCode: 0,
    operatorOnlineMethod: "",
    partyTypeCd: "",
    partySex: "MALE",
    lastName: "",
    firstName: "",
    middleName: "",
    organizationName: "",
    operatorFileName: "",
    managerCd: "",
    isAgent: true,
    isTelRequired: true,
    telExt: "",
    mobileNumber: "",
    hasRemoteAccess: false,
    outputTrunk: "",
    active: true,
    contactContentLoggingEnabled: 0,
    password1: "",
    password2: "",
    announceName: false,
    synchAgentRemoteAddrAndExtensionHost: false
}



//==========================================
export class PartyQuerty extends PaginationQuery {
    partyCd: string | null = null;
    operatorCode: number | null = null;
    partyTypeCd: string | null = null;
    lastName: string | null = null;
    firstName: string | null = null;
    middleName: string | null = null;
    organizationName: string | null = null;
    isAgent: boolean | null = null;
    active: boolean | null = null;
    telExt: string | null = null;
    managerCd: string | null = null;
    partySex: string | null = null;
    accessibleParty: Array<string> = [];
    constructor() { super() }
}

export const GET_PARTY_LIST = 'GET_PARTY_LIST';
export const GET_PARTY_LIST_SUCCESS = 'GET_PARTY_LIST_SUCCESS';
interface GetPartyListAction extends IBaseAction {
    type: typeof GET_PARTY_LIST | typeof GET_PARTY_LIST_SUCCESS
    payload: {
        data: PartyQuerty
    },
}

//==========================================
export type UserProfile = {
    config: string;
    fontSize: number;
    themeName: string;
    numberSearchResultList: number;
}
const userProfileInitialState: UserProfile = {
    config: "{}",
    fontSize: 20,
    themeName: "DEFAULT",
    numberSearchResultList: 20,
}


export interface SecurityProfile {
    userProfile: UserProfile
    //  email: string;
    remoteHostName: string;
    party: Party;
    localHostName: string
    localAddr: string
    remoteAddr: string
}
export const securityProfileInit: SecurityProfile = {
    userProfile: userProfileInitialState,
    party: partyInit,
    localHostName: "",
    localAddr: "",
    remoteHostName: "",
    remoteAddr: "",
}

export const GET_SECURITY_PROFILE = 'GET_SECURITY_PROFILE';
export const GET_SECURITY_PROFILE_SUCCESS = 'GET_SECURITY_PROFILE_SUCCESS';

interface GetSecurityProfileAction extends IBaseAction {
    type: typeof GET_SECURITY_PROFILE | typeof GET_SECURITY_PROFILE_SUCCESS
    payload: {
        data: SecurityProfile
    }
}

export interface Airline {
    name: string;
    users: Array<any>;
    alias: string;
    logo: string;
    flightNumberRanges: Array<any>;
    registers: Array<any>;
}

export const initAirline = {
    name: '',
    alias: '',
    users: [],
    logo: '',
    flightNumberRanges: [],
    registers: []
}

export const GET_AIRLINE = "GET_AIRLINE";
export const GET_AIRLINE_SUCCESS = "GET_AIRLINE_SUCCESS";
export const GET_AIRLINE_FAILURE = "GET_AIRLINE_FAILURE"; 

export interface GetAirlineState {
    data: Airline;
}

interface GetAirlineAction extends IBaseAction {
    type: typeof GET_AIRLINE | typeof GET_AIRLINE_SUCCESS | typeof GET_AIRLINE_FAILURE
    payload: {
        data: Airline
    }
}

export const UPDATE_AGENT_PROFILE_AND_LOG_OUT = 'UPDATE_AGENT_PROFILE_AND_LOG_OUT';
export const UPDATE_SEUCRITY_PROFILE_CONFIG = 'UPDATE_SEUCRITY_PROFILE_CONFIG';
export const UPDATE_SEUCRITY_PROFILE_CONFIG_SUCCESS = 'UPDATE_SEUCRITY_PROFILE_CONFIG_SUCCESS';
export const UPDATE_SEUCRITY_PROFILE_CONFIG_FAILURE = 'UPDATE_SEUCRITY_PROFILE_CONFIG_FAILURE';

export const GET_AGENT_STATE = 'GET_AGENT_STATE';
export const GET_AGENT_STATE_SUCCESS = 'GET_AGENT_STATE_SUCCESS';
export interface AgentStateInfo {
    restRequestPassedTime: number | null;
    telExtHost: string;
    telExtStatus: string;
    telExt: string;
    securityProfile: SecurityProfile;
    isTelExtReachable: boolean
    isTelRequired: boolean
    onlineMethod: string;
    wrapUpTimeDurationRemained?: number
}
export const agentStateInfoInitialState: AgentStateInfo = {
    securityProfile: securityProfileInit,
    telExt: "",
    telExtHost: "",
    telExtStatus: "UNKNOWN",
    onlineMethod: "",
    isTelRequired: false,
    isTelExtReachable: false,
    restRequestPassedTime: null,
}

export interface GetAgentStateAction extends IBaseAction {
    type: typeof GET_AGENT_STATE | typeof GET_AGENT_STATE_SUCCESS
    payload?: {
        data: AgentStateInfo
    }
}


//==========================================
//==========================================

//==========================================
export type UserActionTypes =
    GetPartyListAction
    | GetPartyAction
    | GetSecurityProfileAction
    | GetAgentStateAction 
    | GetAirlineAction
